import Icons from './Icon'

export { ICON_SIZE } from './Icon'
export type { IconProps } from './IconPropsInterface'
export default Icons
